<template lang="pug">
  .event-registration(v-if="eventSku")
    .list-item
      h2 {{title}}
      p {{description}}
      RogueButton(v-if="isLoading" color="white-outline" :disabled="true" :loading="true")
        .open {{registerButtonText}}
      RogueButton(v-else-if="isOpen" color="white-outline" :link="link" @click="$router.push(link)")
        .open {{registerButtonText}}
      RogueButton(v-else color="white-outline" :link="link || '/challenges/leaderboard'")
        .closed {{disabledButtonText}}
</template>
<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { useEventStore } from '@/js/stores/eventStore'
import { useRogue } from '@/js/services/Rogue'

const props = defineProps({
  title: {
    type    : String,
    default : null,
  },
  description: {
    type    : String,
    default : null,
  },
  eventSku: {
    type    : String,
    default : null,
  },
  link: {
    type    : String,
    default : null,
  },
  eventProductId: {
    type    : Number,
    default : null,
  },
  registerButtonText: {
    type    : String,
    default : 'Register Now',
  },
  disabledButtonText: {
    type    : String,
    default : 'Registration Closed',
  },
})

const rogue = useRogue()
const eventStore = useEventStore()

const isLoading = ref<boolean>(true)
const eventConfig = ref<any>({
  products  : [],
  subEvents : [],
  open      : null,
  close     : null,
})

const isOpen = computed<boolean>(() => {
  const open = new Date(eventConfig.value.open)
  const close = new Date(eventConfig.value.close)

  return open && open.getTime() < Date.now() && (!eventConfig.value.close || close.getTime() > Date.now())
})

async function load() {
  await eventStore.loadEventConfig(props.eventSku, rogue)

  eventConfig.value = eventStore.events[props.eventSku]
  isLoading.value = false
}

onMounted(() => {
  load()
})
</script>
<style lang="scss" scoped>

.list-item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  h2 {
    text-align: left;
    margin-right: 5px;
    margin-bottom: 0;
    width: 25%;
  }
  p {
    text-align: center;
    margin-right: 5px;
    margin-bottom: 0;

    @include not-desktop() {
      display: none;
    }
  }
  button {
    margin-left: 30px;
  }
}

.black {
  color: #000000;
  background-color: #ffffff;
}
</style>
